import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ValidvalueselectService {

  private url: string = 'http://localhost:50695/Api/enumValidValueItems?Name=enumFormControl';

  constructor(private http: HttpClient) { }

  getValidValueList(name: string): Observable<any> {
    let url: string;
    const method: string = 'enumValidValueItems';
    url = environment.TDOurl + method + '/' + name;

    return this.http.get<any>(url);
  }
}
